export const refusedExtensions = [
  'bat',
  'js',
  'jar',
  'vb',
  'html',
  'exe',
  'msi',
  'sql',
  'gif'
];

export const imageExtensions = [
  'jpeg',
  'JPEG',
  'jpg',
  'JPG',
  'png',
  'PNG',
  'bmp'
];

export const audioExtensions = ['aac', 'mp4', 'amr', 'mpeg', 'mp3', 'wav'];

export const videoExtensions = ['mp4', '3gpp'];

export const fileExtensions = [
  'pdf',
  'PDF',
  'xls',
  'XLS',
  'doc',
  'DOC',
  'docx',
  'DOCX',
  'xlsx',
  'XLSX',
  'txt',
  'TXT',
  'csv',
  'CSV',
  'zip',
  'xml',
  'epub',
  'rtf'
];

// essas são as extensões permitidas para upload no instagram segundo a documentação deles
// qualquer extensão fora dessas será barrada
export const INSTAGRAM_ALLOWED_EXTENSIONS = [
  'aac',
  'm4a',
  'wav',
  'mp4',
  'png',
  'jpeg',
  'jpg',
  'gif',
  'mp4',
  'ogg',
  'avi',
  'mov',
  'webm'
];
